import BaseModelInstance from './base.model'
import { ResourceType as ModelDefinition } from './model-definitions'

class ResourceType extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default ResourceType
